export function generateArtworkContentId({
  artworkId,
  materialType,
  tileSize,
  frameColor,
}) {
  return `${artworkId}-${tileSize}-${materialType}-${frameColor}`
}

// Reference - fields: https://developers.facebook.com/docs/meta-pixel/implementation/conversion-tracking
// Reference - event types: https://developers.facebook.com/docs/meta-pixel/reference#standard-events
export function itemsToFacebookConversionProducts({
  items,
  value,
  currency,
  contentParams,
}) {
  const contentIds = []
  const contentsMap = {}

  const artworkTiles = []
  const itemsIncludeArt = []
  if (items) {
    for (const item of items) {
      itemsIncludeArt.push(item)
      if (item.orderTiles) {
        artworkTiles.push(...item.orderTiles.filter((t) => t.artwork))
      }
    }
  }

  for (const artworkTile of artworkTiles) {
    itemsIncludeArt.push({
      itemId: generateArtworkContentId({
        artworkId: artworkTile.artwork.id,
        tileSize: artworkTile.tileSize,
        materialType: artworkTile.materialType,
        frameColor: artworkTile.customStyle?.frameColor,
      }),
    })
  }

  for (const item of itemsIncludeArt) {
    contentIds.push(item.itemId)
    if (!contentsMap[item.itemId]) {
      contentsMap[item.itemId] = {
        id: item.itemId,
        quantity: 1,
      }
    } else {
      contentsMap[item.itemId].quantity += 1
    }
  }

  return {
    content_ids: contentIds,
    contents: Object.values(contentsMap),
    value,
    currency: currency || (items[0].totalPrice && items[0].totalPrice.currency),
    content_type: 'product',
    content_name: contentParams.contentName,
    content_category: contentParams.contentCategory,
  }
}

export function generateViewContentParams({
  ids,
  totalPrice,
  contentCategory,
  contentName,
}) {
  const params = {
    content_ids: ids,
    contents: ids.map((id) => ({ id, quantity: 1 })),
    value: totalPrice.value,
    currency: totalPrice.currency,
    content_type: 'product',
  }
  if (contentCategory) {
    params.content_category = contentCategory
  }
  if (contentName) {
    params.content_name = contentName
  }
  return params
}
